import { readable, writable, derived, get } from "svelte/store";
import { loadJSON, loadTopojson, loadMapbox, loadCSV } from "../../utils";
import { topicColors } from "../../colors";

export let points = writable();
export let geoBinsSmall = writable();
export let geoBinsMedium = writable();
export let geoBinsLarge = writable();
export let geoBinsXLarge = writable();
export let allBerlinStats = writable();
export let topics = writable([]);

export let mainTopics = derived(topics, ($topics) => $topics.filter((t) => t.main));

export let nestedTopics = derived(topics, ($topics) => {
	const nestedTopics = {};

	const mainTopics = $topics.filter((t) => t.main);
	const subTopics = $topics.filter((t) => !t.main);

	mainTopics.forEach((t) => {
		nestedTopics[t.id] = {
			...t,
			subtopics: [],
		};
	});

	subTopics.forEach((t) => {
		if (nestedTopics[t.parentId]) {
			nestedTopics[t.parentId].subtopics.push(t);
		} else {
			// console.log(`Parent topic ${t.parentId} not found for subtopic ${t.id}`);
		}
	});
	return nestedTopics;
});

export let currentTopics = derived(topics, ($topics) => $topics.filter((t) => t.current_controversy));

export const loadMapData = async () => {
	const promises = [
		loadJSON(`${PATH}assets/data/points.json`),
		loadJSON(`${PATH}assets/data/bins125.geo.json`),
		loadJSON(`${PATH}assets/data/bins250.geo.json`),
		loadJSON(`${PATH}assets/data/bins500.geo.json`),
		loadJSON(`${PATH}assets/data/bins1000.geo.json`),
		loadJSON(`${PATH}assets/data/berlin_stats.json`),
		loadCSV(`${PATH}assets/data/topics.csv`),
		loadTopojson(),
		loadMapbox(),
	];

	let pointsRaw;
	let geoBinsSmallRaw;
	let geoBinsMediumRaw;
	let geoBinsLargeRaw;
	let geoBinsXLargeRaw;
	let allBerlinStatsRaw;
	let topicsRaw;

	[pointsRaw, geoBinsSmallRaw, geoBinsMediumRaw, geoBinsLargeRaw, geoBinsXLargeRaw, allBerlinStatsRaw, topicsRaw] =
		await Promise.all(promises);

	points.set(pointsRaw);
	geoBinsSmall.set(geoBinsSmallRaw);
	geoBinsMedium.set(geoBinsMediumRaw);
	geoBinsLarge.set(geoBinsLargeRaw);
	geoBinsXLarge.set(geoBinsXLargeRaw);
	allBerlinStats.set(allBerlinStatsRaw);

	topicsRaw.forEach((t) => {
		t.main = !t.subtopic;
		t.parentId = t.main ? null : t.id.split(" --- ")[0];
		t.color = topicColors[t.parentId || t.id] || topicColors["sonstige"];
		t.label = t.category;
		t.labelShort = t.short || t.category;
		t.current_controversy = t.current_controversy === "x";
		t.count = get(allBerlinStats)[t.id];
	});
	topicsRaw.sort((a, b) => b.count - a.count);
	topics.set(topicsRaw);
};
